<template>
  <el-container>
    <el-header>
      <Navbar :dialogLoginVisible.sync="loginFormShow"></Navbar>
    </el-header>
    <el-container class="main_cont">
      <el-main style="height: 100%; padding: 0">
        <el-container style="height: 100%">
          <NavbarLeft active_idx="/ai-qa-scheme"></NavbarLeft>

          <el-aside class="history">
            <div
              style="
                position: absolute;
                top: 0px;
                right: 0;
                width: 248px;
                height: 36px;
                top: 38px;
                right: 100px;
              "
            >
              <el-input
                placeholder="搜索想要的功能"
                @change="searchChange"
                v-model="searchValue"
                style="z-index: 99"
                class="search_input"
              >
                <template slot="append">
                  <i class="el-icon-search"></i>
                </template>
              </el-input>
            </div>

            <el-tabs v-model="activeName" style="height: 100%">
              <el-tab-pane
                label="全部"
                name="0"
                style="height: 100%; position: relative"
              >
                <span slot="label">
                  <div class="title t1">
                    <span
                      :style="{ fontSize: activeName == 0 ? '20px' : '19px' }"
                      >全部</span
                    >
                  </div>
                </span>
                <div class="tab-cont">
                  <!-- <div class="itemB" @click="gotoQa"></div> -->
                  <div
                    class="item"
                    v-for="(item, idx) in his_list"
                    :key="idx"
                    @click="gotoQaByType(item)"
                  >
                    <div class="top">
                      <el-image
                        class="icon"
                        :src="
                          'https://boserai.com/' +
                          encodeURIComponent(item.title) +
                          '@2x.png'
                        "
                        fit="contain"
                      >
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>

                      {{ item.title }}
                    </div>
                    <div class="desc">
                      {{ item.desc }}
                    </div>
                    <div class="bottom">{{ item.userNums }}人使用</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="创作" name="1" style="height: 100%">
                <span slot="label">
                  <div class="title t2">
                    <span
                      :style="{ fontSize: activeName == 1 ? '20px' : '19px' }"
                      >创作</span
                    >
                  </div>
                </span>
                <div class="tab-cont">
                  <div
                    class="item"
                    v-for="(item, idx) in his_list"
                    :key="idx"
                    @click="gotoQaByType(item)"
                  >
                    <div class="top">
                      <el-image
                        class="icon"
                        :src="'https://boserai.com/' + item.title + '@2x.png'"
                        fit="contain"
                      >
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                      {{ item.title }}
                    </div>
                    <div class="desc">
                      {{ item.desc }}
                    </div>
                    <div class="bottom">{{ item.userNums }}人使用</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="工作" name="2" style="height: 100%">
                <span slot="label">
                  <div class="title t2">
                    <span
                      :style="{ fontSize: activeName == 2 ? '20px' : '19px' }"
                      >工作</span
                    >
                  </div>
                </span>
                <div class="tab-cont">
                  <div
                    class="item"
                    v-for="(item, idx) in his_list"
                    :key="idx"
                    @click="gotoQaByType(item)"
                  >
                    <div class="top">
                      <el-image
                        class="icon"
                        :src="'https://boserai.com/' + item.title + '@2x.png'"
                        fit="contain"
                      >
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                      {{ item.title }}
                    </div>
                    <div class="desc">
                      {{ item.desc }}
                    </div>
                    <div class="bottom">{{ item.userNums }}人使用</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="学习" name="3" style="height: 100%">
                <span slot="label">
                  <div class="title t2">
                    <span
                      :style="{ fontSize: activeName == 3 ? '20px' : '19px' }"
                      >学习</span
                    >
                  </div>
                </span>
                <div class="tab-cont">
                  <div
                    class="item"
                    v-for="(item, idx) in his_list"
                    :key="idx"
                    @click="gotoQaByType(item)"
                  >
                    <div class="top">
                      <el-image
                        class="icon"
                        :src="'https://boserai.com/' + item.title + '@2x.png'"
                        fit="contain"
                      >
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                      {{ item.title }}
                    </div>
                    <div class="desc">
                      {{ item.desc }}
                    </div>
                    <div class="bottom">{{ item.userNums }}人使用</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="生活" name="4" style="height: 100%">
                <span slot="label">
                  <div class="title t2">
                    <span
                      :style="{ fontSize: activeName == 4 ? '20px' : '19px' }"
                      >生活</span
                    >
                  </div>
                </span>
                <div class="tab-cont">
                  <div
                    class="item"
                    v-for="(item, idx) in his_list"
                    :key="idx"
                    @click="gotoQaByType(item)"
                  >
                    <div class="top">
                      <el-image
                        class="icon"
                        :src="'https://boserai.com/' + item.title + '@2x.png'"
                        fit="contain"
                      >
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                      {{ item.title }}
                    </div>
                    <div class="desc">
                      {{ item.desc }}
                    </div>
                    <div class="bottom">{{ item.userNums }}人使用</div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
            <!-- -->
          </el-aside>
        </el-container>
      </el-main>
    </el-container>

    <LoginForm
      :dialogLoginVisible.sync="loginFormShow"
      v-if="loginFormShow"
    ></LoginForm>
    <Status></Status>
  </el-container>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import NavbarLeft from "@/components/NavbarLeft.vue";
import imageImageForm from "@/components/imageImageForm";
import LoginForm from "@/components/LoginForm";

import { user_account_req } from "@/api/user";
import {
  interest_fsPage_req,
  interest_gzPage_req,
  interest_edit_req,
  interest_read_req,
} from "@/api/group";
import { qa_template_list_req } from "@/api/qa";
import Status from "@/components/Status";

export default {
  name: "aiQaScheme",
  components: {
    Navbar,
    NavbarLeft,
    imageImageForm,
    LoginForm,
    Status,
  },
  data() {
    return {
      recData: [],
      text: "",
      text2: "",
      loading: false,
      picselected: [], // Must be an array reference!
      show: false,
      bodyBgVariant: "dark",
      tools_show: false,

      progress_value: 0,
      img_create_loading: false,
      needSec: undefined,
      needSecStep: undefined,
      timer: null,
      imgList: [],
      imgIdx: 0,

      // 下拉滚动相关
      pageNum: 1,
      pageSize: 20,
      his_list: [],
      finished: false,
      // 下拉滚动相关

      activeName: undefined,
      ac_data: {}, //账户信息
      searchValue: undefined,
      loginFormShow: false,
      boldclass: "font-weight:700",
    };
  },
  onLoad() {},
  async mounted() {
    if (this.tokenVuex) {
      let _this = this;
      if (this.$route.params.activeName) {
        this.activeName = this.$route.params.activeName.toString();
      } else {
        this.activeName = "0";
      }

      await this.getUserAccountInfo(); //获取账户信息
    } else {
      this.activeName = "0";
      // this.$toast.open({
      //   message: "请先登录噢",
      //   position: 'top',
      //   duration: 3000,
      //   queue: true,
      //   type: 'error',
      // })
    }
  },
  beforeDestroy() {},
  destroyed() {
    //离开路由之后断开websocket连接
    // this.websock.close();
  },
  computed: {
    formVuex: {
      get() {
        // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
        return this.$store.state.imageImage.form;
      },
      set(newVal) {
        this.formVuex = newVal;
      },
    },
    tokenVuex() {
      // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
      return this.$store.state.user.token;
    },
  },
  methods: {
    deleteHis(i) {
      if (this.img_create_loading) {
        return;
      }
      let taskId = this.his_list[i].taskId;
      this.$confirm("", "删除此条记录，您的作品也将一并删除，是否删除?", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        center: true,
        customClass: "_message_box2",
      })
        .then(({ value }) => {
          painting_removeByTid(taskId).then((res) => {
            this.$toast.open({
              message: "已删除",
              position: "top",
              duration: 3000,
              type: "success",
            });

            try {
              if (
                this.his_list[i].list[0].md5 &&
                this.imgList[0].md5 &&
                this.his_list[i].list[0].md5 == this.imgList[0].md5
              ) {
                this.imgList = [];
              }
            } catch (error) {
              console.error(error);
            }
            this.his_list.splice(i, 1);
          });
        })
        .catch(() => {
          // this.$toast.open({
          //     message: '删除失败，请稍后再试',
          //     position: 'top',
          //     duration: 1000,
          //     type: 'error',
          //   });
        });
    },

    // 获取历史记录
    img_page_get(val, searchvalue) {
      // if (!this.tokenVuex) {
      //   return;
      // }
      this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 1)",
        customClass: "my_loading",
      });

      let _this = this;

      let type = undefined;
      let desc = undefined;
      if (this.activeName == 0) {
        type = undefined;
      } else if (this.activeName == 1) {
        type = "创作";
      } else if (this.activeName == 2) {
        type = "工作";
      } else if (this.activeName == 3) {
        type = "学习";
      } else if (this.activeName == 4) {
        type = "生活";
      }
      if (this.searchValue) {
        desc = this.searchValue;
      } else {
        desc = undefined;
      }

      qa_template_list_req(type, desc).then((res) => {
        this.his_list = res.data;
        _this.$loading().close();
      });
    },

    // 历史记录相关 //
    async getUserAccountInfo() {
      const { data, success } = await user_account_req();
      if (success) {
        this.ac_data = data;
      }
    },

    changeIndex(e) {
      this.his_list[e].showMove = true;
      this.$forceUpdate();
      // this.imgList[e].show = !this.imgList[e].show
    },
    changeIndexBack(e) {
      this.his_list[e].showMove = false;
      this.$forceUpdate();
      // this.imgList[e].show = !this.imgList[e].show
    },
    gotoPersonal(item) {
      let obj = {};
      obj.router = "personal";
      obj.uid = item.accountModel.uid;
      this.$router.push({
        name: "test", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
        params: obj,
      });
    },
    goHome() {
      this.$router.push({
        path: "/",
      });
    },
    itemToDetail(item) {
      console.log(item);
      let obj = {};
      obj.router = "explore";
      obj._id = item.id;
      this.$router.push({
        name: "test", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
        params: obj,
      });
    },
    searchChange(e) {
      this.his_list = [];
      this.pageNum = 1;
      this.img_page_get();
    },
    gotoQa() {
      // this.$store.commit('user/change_token') ;
      // if( !this.tokenVuex ){
      //   this.loginFormShow = true ;
      //   return;
      // }

      this.$router.push({
        name: "aiQa", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
      });
    },
    gotoQaByType(item) {
      // this.$store.commit('user/change_token') ;
      // if( !this.tokenVuex ){
      //   this.loginFormShow = true ;
      //   return;
      // }

      // item.router = 'aiQaSchemeqa';
      // this.$router.push({
      //   name: "test", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
      //   params: item
      // });

      this.$router.push({
        // name : "aiQaSchemeqa", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
        path: "/ai-qa-schemeqa",
        query: {
          params: JSON.stringify(item),
        },
      });
    },
  },
  watch: {
    tokenVuex(newQuestion, oldQuestion) {
      // console.log( newQuestion  )
      if (!newQuestion) {
        this.$router.replace({
          name: "home", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
          params: {
            unlogin: true,
          },
        });
      }
    },
    activeName(newVal) {
      this.his_list = [];
      this.pageNum = 1;
      this.img_page_get();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__content {
  height: calc(100% - 55px);
}

::v-deep .el-tabs__item {
  color: #cacad4;
  font-weight: 400;
  padding: 0;
}
::v-deep .el-tabs__nav {
  margin-left: 72px;
}
::v-deep .el-tabs__item.is-active {
  color: #fff;
  font-weight: 500;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: #0b0b1e;
  height: 0;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  background: #222337;
}

/*修改.el-progress背景色*/
::v-deep .el-progress-circle__track {
  stroke: #38394b;
}

::v-deep .modal-class {
  position: relative;
  min-height: 200px;
}

::v-deep .modal-class .chevron-left {
  position: absolute;
  left: 3px;
  top: 45%;
  font-size: 30px;
  color: #fff;
}

::v-deep .modal-class .chevron-right {
  position: absolute;
  right: 3px;
  top: 45%;
  font-size: 30px;
  color: #fff;
  z-index: 999;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: #111225;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  background: #222337;
}

::v-deep .el-textarea__inner {
  background: #222337;
  border: none;
  color: #fff;

  &::placeholder {
    color: #49495a;
  }

  &::-webkit-input-placeholder {
    /* WebKit browsers 适配谷歌 */
    color: #49495a;
  }

  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 适配火狐 */
    color: #49495a;
  }

  &::-moz-placeholder {
    /* Mozilla Firefox 19+ 适配火狐 */
    color: #49495a;
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10+  适配ie*/
    color: #49495a;
  }
}
::v-deep .el-slider__bar {
  background-color: #006fff;
}

.container-fluid {
  // background-color: #f5f6f9;
  padding-left: 5px;
  padding-right: 5px;
  height: calc(100%);
}

::v-deep .main_cont {
  height: calc(100vh - 66px);
  background: #0b0b1f;
  .el-upload-dragger {
    width: 100%;
    height: 100%;
    border: none;
    background-color: #0b0b1f !important;
  }

  .upload-file .el-upload-list .el-upload-list__item:hover .el-icon-close {
    display: none;
  }
}

.content {
  box-sizing: border-box;
  // background-color: #f5f6f9;
  height: 100%;

  .toolbox {
    text-align: left;
    padding: 12px;
    box-sizing: border-box;
    font-size: 14px;
    overflow: hidden;
    height: 100%;
    padding-right: 20px;
    /* 防止滚动条遮挡内容 */

    .toolbox_cont {
    }

    .title {
      font-weight: 700;
      color: #333;
      padding-bottom: 8px;
      border-bottom: 2px solid #317cf6;
    }

    .icon-item {
      width: 25%;
      margin-bottom: 12px;

      .icon {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #51a280;
        margin: 0 auto;
      }

      .name {
        font-size: 12px;
        text-align: center;
        margin-top: 3px;
      }
    }
  }

  .toolbox {
    overflow: hidden;
  }

  .toolbox::-webkit-scrollbar {
    width: 1px;
    display: flex;
  }

  .toolbox::-webkit-scrollbar-thumb {
    background: #3ba9f8;
  }

  .toolbox:hover {
    overflow-y: auto;
    width: calc(100% - 1px);
  }

  .tool-main {
    .tool-main-cont {
      justify-content: center;
      align-items: center;
      height: 450px;
      width: 450px;
      margin: 0 auto;
      // background-color: #006FFF;
      background-image: url("../assets/img/textform/bg.png");
      flex-direction: column;
    }
  }

  .getpromptBtn {
    width: 120px;
    height: 30px;
    background: #0b0b1f;
    border-radius: 14px;
    border: 1px solid #006fff;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #006fff;
    line-height: 28px;
  }
}

.eraser_type {
  cursor: url("../assets/img/textform/eraser1.png") 12 12, auto;
}
.pen_type {
  cursor: url("../assets/img/textform/pen1.png") 12 12, auto;
}

.img-cont {
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  background-color: #f5f6f9;
  margin: 0 auto;
}

.bottom-cont {
  box-sizing: border-box;
  border: none;
  max-height: 124px;
  padding: 10px 0;
  //min-height: 66px;
  background: #222337;
  border-radius: 10px;

  textarea {
    border: none;
    resize: none;
    cursor: pointer;
  }
}

.history {
  text-align: left;
  padding: 12px;
  padding-top: 40px;
  box-sizing: border-box;
  font-size: 14px;
  overflow: hidden;
  height: 100%;
  width: calc(100% - 220px) !important;
  background: #0b0b1f;
  position: relative;

  .title {
    box-sizing: border-box;
    padding: 0 15px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    position: relative;
  }

  ::v-deep .el-tabs__item.is-active .title:after {
    content: "";
    display: block;
    width: 20px;
    height: 4px;
    background: #006fff;
    border-radius: 2px;
    position: absolute;
    bottom: 2px;
  }

  ::v-deep .el-tabs__active-bar {
    background-color: transparent !important;
  }

  ::v-deep .el-tabs__item.is-active .t1:after {
    left: 23px;
  }

  ::v-deep .el-tabs__item.is-active .t2:after {
    left: 23px;
  }

  ::v-deep .el-tabs__header.is-top {
    margin-bottom: 11px;
  }

  .tab-cont {
    width: 100%;
    max-height: 100%;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .itemB {
      width: 514px;
      height: 144px;
      background: #1b1b49;
      border-radius: 10px;
      margin-bottom: 14px;
      margin-right: 14px;
      background-image: url("../assets/img/qa/aiChat.png") !important;
      background-repeat: no-repeat;
      background-size: 100%;
      cursor: pointer;
    }
    .item {
      width: 250px;
      height: 144px;
      background: #222337;
      border-radius: 10px;
      margin-bottom: 14px;
      margin-right: 14px;
      padding: 15px 15px 0 15px;
      position: relative;
      cursor: pointer;
      .top {
        height: 36px;
        display: flex;
        align-items: center;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
        .icon {
          height: 36px;
          width: 36px;
          background-color: palegreen;
          font-size: 17px;
          font-weight: 500;
          color: #ffffff;
          margin-right: 7px;
          border-radius: 50%;
        }
      }
      .desc {
        margin-top: 7px;
        font-size: 13px;
        color: #9a9ab7;
        line-height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp: 2; //显示的行
      }
      .bottom {
        bottom: 0;
        left: 0;
        right: 0;
        position: absolute;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        color: #9a9ab7;
        text-indent: 15px;
        background: #2b2c43;
        border-radius: 0 0 10px 10px;
      }
    }
  }
}

.carousel-cont .carousel-caption {
  left: 0 !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
}

.exit_hover .arrowClickIcon {
  display: none;
}
.exit_hover:hover .arrowClickIcon {
  display: inline-block;
}

::v-deep .search_input {
  .el-input__inner {
    background-color: #252739;
    border-radius: 18px 0 0 18px;
    border: none;
    color: #9a9ab7;
    &::placeholder {
      color: #9a9ab7;
    }
  }
  .el-input-group__append {
    background-color: #252739;
    border: none;
    border-radius: 0 18px 18px 0;
  }
}

::v-deep .el-tab-pane {
  padding: 0 85px 0 88px;
}
</style>
